export const SNACKBAR = {
  SHOW_MESSAGE: 'SNACKBAR_SHOW_MESSAGE'
};

export const createMessageByName = (name) => ({
  create: name ? `${name} has been created.` : 'Create successful.',
  update: name ? `${name} has been updated.` : 'Update successful.',
  deleteId: name ? `${name} has been deleted` : 'Delete successful.',
});

export const createMessageOnActionByName = (action, name) => (
  createMessageByName(name)[action]
);

export const showMessage = ({ action, message }) => ({
  type: SNACKBAR.SHOW_MESSAGE,
  message: !action ? message : createMessageOnActionByName(action, message)
});



// WEBPACK FOOTER //
// ./src/store/snackbar/snackBarActions.js